import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationService } from '../navigation.service';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ScopeSelectDefault } from '../../../../shared/components/ms-select/ms-select.component';

@Component({
	selector: 'navigation-select',
	templateUrl: './navigation-select.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class NavigationSelectComponent implements OnInit, OnInit, OnDestroy {
	@Input() formGroup: FormGroup;
	@Input() title: string;
	@Input() key: string;
	@Input() items: Observable<ScopeSelectDefault[]>;

	/**
	 * Constructor
	 */
	constructor(private _navigationService: NavigationService) {}

	//  -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
